import { createSSRApp } from 'vue';
import VueViewer from 'v-viewer';
import { createHead } from '@vueuse/head';

import App from './App.vue';

// export a factory function for creating a root component
export default function (props) {
  const app = createSSRApp(App, props);
  app.config.globalProperties.$publicPath = props.root.vue_publicPath || '/report';
  const head = createHead();

  app.use(head);
  app.use(VueViewer);

  return { app, head };
}
